module.exports = __webpack_public_path__ + "static/media/GoudyNational-Italic.d22b33df.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/GoudyNational-Italic.ttf
// module id = 2976
// module chunks = 51